class Utils {
  doLogin() {
    window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname)
  }
  // Number
  keepDecimalFixed(num, length = 0, round = true) {
    // 四舍五入
    if (round) return num.toFixed(length)
    // 不四舍五入
    let numLength = Math.pow(10, length)
    return (Number.parseInt(num * numLength) / numLength).toFixed(length)
  }
  // Date
  /**
   * @name 时间格式化
   * @param fmt 如 yyyyMMdd hh:mm:ss
   * @param date
   * @returns {*}
   */
  dateFormat(fmt, date) {
    date = new Date(date)
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }
  /**
   * @name 日期字符转日期对象
   * @param datestr ('20180522101000')
   * @returns {Date}
   */
  datestrToDate(datestr) {
    let str = datestr.toString()
    return new Date(str.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})+/mg, '$1-$2-$3 $4:$5:$6'))
  }
}
export default Utils

/**
 * @name 时间格式化(该方法以提入到Utils类中，优先使用Utils类)
 * @param fmt
 * @param date
 * @returns {*}
 */
export function dateFormat(fmt, date) {
  date = new Date(date)
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
};

/**
 * @name 日期字符转日期对象(该方法以提入到Utils类中，优先使用Utils类)
 * @param datestr ('20180522101000')
 * @returns {Date}
 */
export function datestrToDate(datestr) {
  let str = datestr.toString()
  return new Date(str.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})+/mg, '$1-$2-$3 $4:$5:$6'))
}
